import { Dictionary } from '#models/questionnaire';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import * as React from 'react';

type FunctionChildren = (props: FormikProps<Dictionary>) => React.ReactNode;
interface FormContainerProps {
  initialValues: Dictionary;
  validationSchema?: any;
  onSubmit: (values: any, helpers?: FormikHelpers<any>) => void;
  children: FunctionChildren | React.ReactNode;
}

export const FormContainer = ({ initialValues, validationSchema, onSubmit, children }: FormContainerProps) => (
  <Formik
    validateOnChange
    validateOnBlur
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {(formProps: FormikProps<Dictionary>) =>
      typeof children !== 'function' ? <Form>{children}</Form> : children(formProps)
    }
  </Formik>
);
